var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 2.874a.65.65 0 0 1 .92 0l4.666 4.666a.65.65 0 0 1 0 .92L8.46 13.126a.65.65 0 0 1-.92-.919l3.557-3.557H3.333a.65.65 0 1 1 0-1.3h7.764L7.54 3.793a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjU0MDM3IDIuODczNzFDNy43OTQyMSAyLjYxOTg3IDguMjA1NzYgMi42MTk4NyA4LjQ1OTYxIDIuODczNzFMMTMuMTI2MyA3LjU0MDM4QzEzLjM4MDEgNy43OTQyMiAxMy4zODAxIDguMjA1NzggMTMuMTI2MyA4LjQ1OTYyTDguNDU5NjEgMTMuMTI2M0M4LjIwNTc2IDEzLjM4MDEgNy43OTQyMSAxMy4zODAxIDcuNTQwMzcgMTMuMTI2M0M3LjI4NjUzIDEyLjg3MjQgNy4yODY1MyAxMi40NjA5IDcuNTQwMzcgMTIuMjA3TDExLjA5NzQgOC42NUgzLjMzMzMyQzIuOTc0MzMgOC42NSAyLjY4MzMyIDguMzU4OTkgMi42ODMzMiA4QzIuNjgzMzIgNy42NDEwMiAyLjk3NDMzIDcuMzUgMy4zMzMzMiA3LjM1SDExLjA5NzRMNy41NDAzNyAzLjc5Mjk1QzcuMjg2NTMgMy41MzkxMSA3LjI4NjUzIDMuMTI3NTYgNy41NDAzNyAyLjg3MzcxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";